import { useParams } from "react-router-dom";

import { PageLayout } from "@/App/Router/PageLayout";

export function FilePageLayout() {
  const { fileId } = useParams();
  return <PageLayout title={`Roboto - File - ${fileId}`} />;
}
